const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

interface ServiceWorkerConfig {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
  onOfflineReady?: () => void;
}

export function registerSW(config?: ServiceWorkerConfig) {
  if ("serviceWorker" in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL!, window.location.href);

    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

    window.addEventListener("load", () => {
      registerValidSW(swUrl, config);
    });

    if (isLocalhost) {
      // if "." is clicked 3 times in 1 second
      // triggers an unregister and a cache clear
      let dotPressCount = 0;
      let dotPressTimer: NodeJS.Timeout | null = null;

      const handleTripleDotPress = () => {
        console.log("Service Worker: Force update triggered by user.");
        navigator.serviceWorker.ready
          .then((registration) => {
            return registration.unregister();
          })
          .then(() => {
            return caches.keys().then((cacheNames) => {
              return Promise.all(
                cacheNames.map((cacheName) => {
                  if (cacheName.startsWith("mymarket-")) {
                    return caches.delete(cacheName);
                  }
                  return Promise.resolve();
                }),
              );
            });
          })
          .then(() => {
            registerValidSW(swUrl, config);
          });
      };

      window.addEventListener("keydown", (event) => {
        if (event.key === ".") {
          dotPressCount++;

          if (dotPressCount === 1) {
            dotPressTimer = setTimeout(() => {
              dotPressCount = 0;
            }, 1000);
          }

          if (dotPressCount === 3) {
            if (dotPressTimer) {
              clearTimeout(dotPressTimer);
              dotPressTimer = null;
            }
            dotPressCount = 0;
            handleTripleDotPress();
          }
        }
      });
    }
  }
}

function registerValidSW(swUrl: string, config?: ServiceWorkerConfig) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log("Service Worker registered successfully:", registration);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              console.log(
                "New content is available and will be used when all tabs for this page are closed.",
              );
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log("Content is cached for offline use.");
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
              if (config && config.onOfflineReady) {
                config.onOfflineReady();
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
